import { Injectable } from '@angular/core';
import { ToastController, ToastOptions } from '@ionic/angular';
import { ToastType } from '@shared/types/toast-type';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private activeToast?: HTMLIonToastElement;

  constructor(public toastController: ToastController) {}

  async showToast(toastType: ToastType, message: string, duration?: number) {
    const iconMap: Record<ToastType, string> = {
      warning: 'warning',
      error: 'alert-circle',
      info: 'information-circle',
      success: 'checkmark-circle',
    };

    const options: ToastOptions = {
      message: message ?? 'An unexpected problem occurred. Please try again later.',
      mode: 'ios',
      icon: iconMap[toastType],
      duration: duration ?? (toastType === 'error' ? undefined : 2000),
      cssClass: [toastType + '-toast', ...(message.length > 130 ? ['auto-height'] : [])],
      position: 'top',
      buttons: [
        {
          side: 'end',
          icon: 'close-circle-outline',
          role: 'cancel',
        },
      ],
      id: 'toast',
    };

    if (this.activeToast) {
      await this.activeToast.dismiss();
      this.activeToast = undefined;
    }

    const toast = await this.toastController.create(options);
    this.activeToast = toast;

    toast.onDidDismiss().then(() => {
      if (this.activeToast === toast) {
        this.activeToast = undefined;
      }
    });

    await toast.present();
  }
}
